import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { injectStrict } from '@apps/main/modules/helpers/injectStrict';
import { RecipeStateKey } from '@apps/main/modules/state/state';
import type {
  FerryFilterEvents,
  FerryFilters,
} from '@apps/main/new-desktop/modules/ferryFilters';
import { FerryFilterType } from '@apps/main/new-desktop/modules/ferryFilters';

import { FilterType } from '../../../modules/filters';

import {
  getArrivalTimeRangeSliderFilter,
  getDefaultFilters,
  getDepartureTimeRangeSliderFilter,
  getStringRangeType,
} from './ferryListFiltersStore.logic';

export const useFerryListFiltersStore = defineStore(
  'FerryListFiltersStore',
  () => {
    const recipeState = injectStrict(RecipeStateKey);

    // State
    const isPanelOpened = ref<boolean>(false);

    // Actions
    function openPanel(): void {
      isPanelOpened.value = true;
    }

    function closePanel(): void {
      isPanelOpened.value = false;
    }

    function update(action: FerryFilterEvents): void {
      switch (action.filterType) {
        case FerryFilterType.ArrivalTime: {
          onUpdateArrivalTimeFilter(action);
          break;
        }
        case FerryFilterType.DepartureTime: {
          onUpdateDepartureTimeFilter(action);
          break;
        }
      }
    }

    function onUpdateArrivalTimeFilter(action: FerryFilterEvents): void {
      if (action.data.filterType === FilterType.RangeSlider) {
        const ingredient = recipeState.getFerryIngredient(
          action.data.ingredientId
        );
        ingredient.filters.arrivalTimeFilters = getStringRangeType(
          action.data.range
        );
      }
    }

    function onUpdateDepartureTimeFilter(action: FerryFilterEvents): void {
      if (action.data.filterType === FilterType.RangeSlider) {
        const ingredient = recipeState.getFerryIngredient(
          action.data.ingredientId
        );

        ingredient.filters.departureTimeFilters = getStringRangeType(
          action.data.range
        );
      }
    }

    // Getters

    const filters = computed<FerryFilters | null>(() => {
      if (recipeState.ferryOnlyRecipe.value?.length === 0) {
        return null;
      }

      const newFilters: FerryFilters = getDefaultFilters();

      recipeState.ferryOnlyRecipe.value.forEach((ferry) => {
        if (ferry) {
          newFilters.arrivalTime.filters.push(
            getArrivalTimeRangeSliderFilter(ferry)
          );

          newFilters.departureTime.filters.push(
            getDepartureTimeRangeSliderFilter(ferry)
          );
        }
      });

      return newFilters;
    });

    return {
      // State
      isPanelOpened,

      // Actions
      closePanel,
      openPanel,
      update,

      // Getters
      filters,
    };
  }
);
